import { render, staticRenderFns } from "./PresentationSlides.vue?vue&type=template&id=6694fd8c&scoped=true&lang=pug"
import script from "./PresentationSlides.vue?vue&type=script&lang=ts"
export * from "./PresentationSlides.vue?vue&type=script&lang=ts"
import style0 from "./PresentationSlides.vue?vue&type=style&index=0&id=6694fd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694fd8c",
  null
  
)

export default component.exports